const registerStaffES = {
	step: "Paso {{step}} de 3",

	step1: {
		title: "Crear cuenta",
		email: "correo electrónico",
		firstName: "Nombre",
		lastName: "Apellido",
		phone: "Número de teléfono",
		password: "Contraseña",
		confirmPassword: "Confirmar contraseña",
		remember: "Recordarme",
		register: "Registrar",
		registering: "Registrando...",
	},

	step2: {
		title: "Registra tu negocio",
		shopName: "Nombre del negocio",
		address: "Dirección",
		city: "Ciudad",
		country: "País",
		postalCode: "Código postal",
		description: "Descripción",
		category: "Tipo de negocio",
		openingHours: "Horario de apertura",
		closed: "Cerrado",
		socials: "Redes sociales (opcional)",
		instagram: "URL de Instagram",
		facebook: "URL de Facebook",
		tiktok: "URL de TikTok",
		website: "Sitio web",
		next: "Siguiente paso",
		registering: "Registrando...",
	},

	step3: {
		title: "Servicios y fotos",
		description: "Agrega al menos un servicio para finalizar el registro.",
		photos: "Fotos del portafolio",
		upload: "Subir fotos",
		finish: "Finalizar registro",
		registering: "Registrando...",
	},

	errors: {
		fillRequired: "Por favor completa todos los campos obligatorios.",
		passwordMatch: "Las contraseñas no coinciden.",
		uploadImages: "Sube al menos una foto antes de finalizar.",
		invalidInvite: "Invitación inválida o expirada.",
		mustAcceptTerms: "Debes aceptar los Términos y Condiciones para continuar.",
	},

	success: {
		adminCreated: "Administrador creado con éxito — ahora registra tu negocio.",
		returning: "¡Bienvenido de nuevo! Continúa registrando tu negocio.",
	},

	days: {
		Monday: "Lunes",
		Tuesday: "Martes",
		Wednesday: "Miércoles",
		Thursday: "Jueves",
		Friday: "Viernes",
		Saturday: "Sábado",
		Sunday: "Domingo",
	},
};

export default registerStaffES;
